
import {Component, Vue} from 'vue-property-decorator';
import {parseTime} from "@/filters";
import {getReceiptAllocateRecord} from "@/api/invoice/index";

@Component({
  name: 'BindReceiptDesc',
})
export default class InvoiceReconciliationDesc extends Vue {

  public showDialog = false;
  public loading = false;
  public tableCol: any = [
    {
      label: "发票号码",
      prop: "receiptCode",
      key: "receiptCode"
    },
    {
      label: "绑定金额",
      prop: "allocateAmount",
      key: "allocateAmount",
    },
    {
      label: "绑定时间",
      prop: "createdTime",
      key: "createdTime",
      render: (prop, row) => {
        return parseTime(row.createdTime, "{y}-{m}-{d} {h}:{i}")
      }
    },
  ]
  private table = {
    list: [] as any[],
  };

  private async getList(obj) {
    getReceiptAllocateRecord({id: obj.id})
        .then(({data}) => {
          this.table.list = data as any[];
          this.loading = false;
        })
  }

  public async openDialog(obj) {
    this.showDialog = true;
    this.getList(obj)
  }
}
